import React, {FunctionComponent, useCallback} from "react";
import {OpenSiteButton} from "../openSiteButton";
const styles = require("./recruitSection.component.scss");

interface RecruitButtonProps {
    title: string;
    subtitle: string;
    ctaText: string;
    lastSection?: boolean;
}


export const RecruitSection: FunctionComponent<RecruitButtonProps> = props => {
    const {title, subtitle, ctaText, lastSection} = props;

    const recruitHandler = useCallback(() => {
        window.open('https://careers.meltwater.com/current-openings/');
    }, []);

    return (
        <div className={`${styles.container} ${lastSection ? styles.lastSection : ''}`}>
            <div className={styles.recruitButtonTextContainer}>
                <h2>
                    {title}
                </h2>
                <div className={styles.recruitButtonSubTitle}>
                    {subtitle}
                </div>
            </div>
            <div className={styles.recruitButtonButtonContainer}>
                <OpenSiteButton text={ctaText} onClick={recruitHandler} />
            </div>
        </div>
    );
};
